import { createContext, type ReactNode } from "react";

export const ComposerNarrowContext = createContext<boolean | null>(null);

export const ComposerNarrowProvider = ({
  isNarrow,
  children
}: {
  isNarrow: boolean;
  children: ReactNode;
}) => (
  <ComposerNarrowContext.Provider value={isNarrow}>
    {children}
  </ComposerNarrowContext.Provider>
);
